export const adaptPlanCuidado = (planData) => {
    const tipoModulo = planData.idTipoModuloNavigation.abreviacion + " - " + planData.idTipoModuloNavigation.descripcion;
    return {
        id: planData?.idPlanCuidado,
        csPlan: planData?.codigoSap,
        name: planData?.nombre,
        tm: planData?.tM,
        shipment: planData?.envios,
        active: planData?.activo,
        acuerdo: planData?.planCuidadoAtributo.length > 0,
        estado: planData?.idPlanCuidadoEstado,
        professional: planData?.profesionales,
        tipoModulo: tipoModulo
    }
}

export const adaptPlanCuidadoArray = (
    planesCuidadoData
) => {
    return structuredClone(planesCuidadoData?.allPlanCuidadoWithoutPaging)
        ?.map(planes => adaptPlanCuidado(planes));
}